export class Combustivel {
  id: number;
  combustivel: string;
  codigoTCE: string;
  ativo: boolean;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/combustiveis/shared/combustivel.model.ts
 **/